import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthLayout from "../../../layouts/Auth";
import { useLoginMutation } from "../../../features/Auth/authApi";
import Error from "../../ErrorMessage";
import routes from "../../../config/routeConfig";

const initialValues = {
  email: "",
  password: "",
};

export default function AdminLogin() {
  const navigate = useNavigate();
  const [formValues, setFormValues] = useState(initialValues);
  const [error, setError] = useState("");
  const [login, { isSuccess, isError, error: loginError }] = useLoginMutation();

  const handleValueChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    login(formValues);
  };

  useEffect(() => {
    if (isSuccess) {
      navigate(routes.admin.dashboard);
      setFormValues(initialValues);
    } else if (isError) {
      setError(loginError.data);
    }
  }, [isSuccess, isError]);

  return (
    <AuthLayout
      isForLogin
      onSubmit={handleSubmit}
      title="Sign in to Admin Account"
    >
      <div className="rounded-md shadow-sm -space-y-px">
        <div>
          {isError && <Error error={error} />}
          <label htmlFor="email-address" className="sr-only">
            Email address
          </label>
          <input
            id="email-address"
            name="email"
            type="email"
            autoComplete="email"
            onChange={handleValueChange}
            value={formValues.email}
            required
            className="login-input rounded-t-md"
            placeholder="Email address"
          />
        </div>
        <div>
          <label htmlFor="password" className="sr-only">
            Password
          </label>
          <input
            id="password"
            name="password"
            type="password"
            onChange={handleValueChange}
            value={formValues.password}
            autoComplete="current-password"
            required
            className="login-input rounded-b-md"
            placeholder="Password"
          />
        </div>
      </div>
      <div className="flex items-center justify-end">
        <div className="text-sm">
          <a
            href="#"
            className="font-medium text-violet-600 hover:text-violet-500"
          >
            Forgot your password?
          </a>
        </div>
      </div>
    </AuthLayout>
  );
}
